import { getStore } from '../store/Store';
import { action } from 'satcheljs/lib/legacy';
import { setShowFolderPane } from '../actions/setShowFolderPane';
import setFolderPaneCollapsedState from '../services/setFolderPaneCollapsedState';
import LayoutChangeSource from '../store/schema/LayoutChangeSource';
import logFolderPaneState from '../helpers/logFolderPaneState';

/**
 * Toggle folder pane expansion collapse state on user click on hamburger button
 */
export default action('toggleFolderPaneExpansion')(function toggleFolderPaneExpansion() {
    const folderPaneShown = getStore().showFolderPane;

    // Toggle the state
    setShowFolderPane(!folderPaneShown /* showFolderPane */);

    // Persist the state
    setFolderPaneCollapsedState(folderPaneShown /* isCollapsed */);

    // log show state change for folder pane
    logFolderPaneState(
        LayoutChangeSource.ToggleFolderPane,
        !folderPaneShown, // folderPaneNewShowState
        folderPaneShown // folderPaneOldShowState
    );
});
